import { useContext } from "react";
import { ThemeContext } from "styled-components";
import { useTranslation } from "react-i18next";

import githubLinkLight from "../../assets/projects/github-link-light.svg";
import githubLinkDark from "../../assets/projects/github-link-dark.svg";
import chainLight from "../../assets/projects/chain-light.svg";
import chainDark from "../../assets/projects/chain-dark.svg";

import { Card } from "./styles";

interface Props {
  projects: Array<{
    imgSrc?: string;
    title: string;
    description: string;
    techs: string[];
    prodURL?: string | null;
    githubURL: string;
  }>;
}

export function ProjectListComponent({ projects }: Props) {
  const { title } = useContext(ThemeContext);
  const { t } = useTranslation();

  return (
    <>
      {projects.map((project) => {
        return (
          <>
            <Card>
              <img src={project.imgSrc} alt={project.title} />

              <div className="card-texts-container">
                <p className="title">{project.title}</p>
                <p className="description">{project.description}</p>
                <p className="techs">
                  {project.techs.map((tech) => {
                    if (tech === project.techs[project.techs.length - 1]) {
                      return tech;
                    } else {
                      return tech + " - ";
                    }
                  })}
                </p>
              </div>
              <div className="card-links-container">
                {project.prodURL ? (
                  <a href={project.prodURL} target="_blank" rel="noreferrer">
                    <img
                      src={title === "light" ? chainLight : chainDark}
                      alt="link do projeto"
                    />
                    {t("livePreview")}
                  </a>
                ) : (
                  <></>
                )}

                <a href={project.githubURL} target="_blank" rel="noreferrer">
                  <img
                    src={title === "light" ? githubLinkLight : githubLinkDark}
                    alt="link do repositorio github"
                  />
                  {t("viewCode")}
                </a>
              </div>
            </Card>
          </>
        );
      })}
    </>
  );
}
